import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../common/Header";
import Grats from "../../assets/Grats";
import Logo from "../../assets/Logo";
import SadFace from "../../assets/SadFace";
import * as actions from "../../state/actions/onboarding";
import { track } from "../../api/heap";

const contactUrl = `${process.env.REACT_APP_DOMAIN}/support`;
const learnMoreUrl = `${process.env.REACT_APP_DOMAIN}/faq`;
const dashboardUrl = `${process.env.REACT_APP_DASHBOARD_HOST}/dashboard`;

class Decision extends Component {
  componentDidMount() {
    window.onbeforeunload = null;

    if (
      !this.props.noPropsCheck &&
      this.props.step.approved === null &&
      !this.props.step.decisionRan
    ) {
      this.timeout = setTimeout(() => {
        this.timeout = null;
        this.props.startOver();
      }, 1000);
    }

    if (this.props.step.approved) {
      window.location = dashboardUrl;
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  // TODO: Implement pending status, create application #'s to reference
  // and store in Firebase
  renderPending = () => {
    const thankYouTextStyle = {
      fontFamily: "HelveticaNeue-Bold",
      fontSize: "16px",
      color: "#99B5B7",
      letterSpacing: "0.14px",
      textAlign: "center",
      paddingTop: 30
    };
    track("ONBOARDING_FINAL_STEP_PENDING");

    return (
      <div className="outerStack-mobile sm:outerStack">
        <p className="font-bold text-gray-600 text-2xl my-4 pb-2">THANK YOU</p>
        <div className="stepDescriptionText" style={{ padding: "0 0 30px 0" }}>
          Approval Pending
        </div>
        <div className="innerStack">
          <div
            className="textContainer"
            style={{ maxWidth: 300, paddingTop: 12 }}
          >
            {/*
              <span>Your application number is </span>
              <span
                style={{ fontFamily: "HelveticaNeue-Bold", color: "#28EBC1" }}
              >
                #TH15N33D5T0831MP73M3NT3D
              </span>
            */}
            <span>
              We are reviewing your application and will get back to you
              shortly.
            </span>
          </div>
          <a href={learnMoreUrl}>
            <input
              type="button"
              name="button"
              value="Learn More"
              className="continueButton cursor-pointer hover:text-green-primary"
              style={{ backgroundColor: "black" }}
            />
          </a>
          <div className="textContainer" style={{ paddingTop: 12 }}>
            <span>Have any questions? </span>
            <a href={contactUrl} style={{ color: "#28EBC1" }}>
              Contact Us
            </a>
          </div>
        </div>
      </div>
    );
  };

  renderIdInvalid = () => {
    const thankYouTextStyle = {
      fontFamily: "HelveticaNeue-Bold",
      fontSize: "16px",
      color: "#99B5B7",
      letterSpacing: "0.14px",
      textAlign: "center",
      paddingTop: 30
    };
    track("ONBOARDING_FINAL_STEP_ID_INVALID");

    const { entityToken } = this.props.user || {};

    const docUploadContainer = entityToken ? (
      <div className="textContainer" style={{ maxWidth: 300, paddingTop: 12 }}>
        <div>
          <input
            type="button"
            name="button"
            value={"Upload Documents"}
            onClick={() => {
              console.log("Clicked on Upload Documents");
              this.props.history.push("/verifyiddocs");
            }}
            className="continueButton cursor-pointer"
          />
        </div>
      </div>
    ) : (
      ""
    );

    return (
      <div className="outerStack-mobile sm:outerStack">
        <p className="font-bold text-gray-600 text-2xl my-4 pb-2">THANK YOU</p>
        <div className="stepDescriptionText" style={{ padding: "0 0 30px 0" }}>
          Approval Pending
        </div>
        <div className="innerStack">
          <div
            className="textContainer"
            style={{ maxWidth: 300, paddingTop: 12 }}
          >
            <span>
              Looks like we need further information to verify your identity.
              Please check your email for details
            </span>
            {entityToken ? (
              <>
                <span> or</span>
                <span className="font-bold">
                  {" "}
                  click the button below to complete your application.
                </span>
              </>
            ) : (
              <span>.</span>
            )}
          </div>
          {docUploadContainer}
          <a href={learnMoreUrl}>
            {entityToken ? (
              <input
                type="button"
                name="button"
                value="Learn More"
                rel="noopener noreferrer"
                target="_blank"
                className="bg-transparent underline hover:text-green-primary mb-4 cursor-pointer"
              />
            ) : (
              <input
                type="button"
                name="button"
                value="Learn More"
                className="continueButton cursor-pointer hover:text-green-primary"
                style={{ backgroundColor: "black" }}
              />
            )}
          </a>
          <div className="textContainer" style={{ paddingTop: 12 }}>
            <span>Have any questions? </span>
            <a
              href={contactUrl}
              rel="noopener noreferrer"
              target="_blank"
              className="hover:underline"
              style={{ color: "#28EBC1" }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    );
  };

  renderApproved = () => {
    const { amount } = this.props.step;
    track("ONBOARDING_FINAL_STEP_APPROVED");

    return this.props.isMobile ? (
      <div className="outerStack-mobile sm:outerStack">
        <div className="approvedText font-bold" style={{ padding: "30px 0" }}>
          Congratulations!
        </div>
        <div className="innerStack">
          <Grats style={{ padding: "0 0 30px 0" }} className="m-auto" />
          <div
            className="approvedDescriptionText m-auto"
            style={{ maxWidth: 300 }}
          >
            <span className="font-bold">You’re approved for</span>{" "}
            <span
              style={{ fontFamily: "HelveticaNeue-Bold", color: "#28EBC1" }}
            >
              ${amount}
            </span>{" "}
            <span>credit</span>
          </div>
          <div
            className="textContainer"
            style={{ maxWidth: 230, paddingTop: 12 }}
          >
            Please check your email for card shipping details.
          </div>
          <a href={dashboardUrl}>
            <input
              type="button"
              name="button"
              value="Continue to Dashboard"
              className="continueButton"
            />
          </a>
        </div>
      </div>
    ) : (
      <Grats className="m-auto" />
    );
  };

  renderDenied = () => {
    const sorryTextStyle = {
      fontFamily: "HelveticaNeue-Bold",
      fontSize: "16px",
      color: "#99B5B7",
      letterSpacing: "0.14px",
      textAlign: "center",
      paddingTop: 30
    };
    track("ONBOARDING_FINAL_STEP_DENIED");

    return (
      <div className="outerStack-mobile sm:outerStack">
        <p className="font-bold text-gray-600 text-2xl my-4 pb-2">
          SORRY
        </p>
        <SadFace style={{ margin: "0 auto" }} className="py-8" />
        <p className="font-bold text-gray-600 text-xl my-4 pb-2">
          Thank you for your interest in TomoCredit.
        </p>
        <div className="innerStack">
          <div
            className="textContainer"
            style={{ maxWidth: 300, paddingTop: 12 }}
          >
            <span>
              Unfortunately we couldn't qualify you this time. You will receive
              an email shortly with more details. If you have questions, please{" "}
            </span>
            <a href={contactUrl} style={{ color: "#28EBC1" }}>
              contact us
            </a>
            .
          </div>
          <a href={learnMoreUrl}>
            <input
              type="button"
              name="button"
              value="Close"
              className="continueButton"
              style={{ backgroundColor: "black" }}
            />
          </a>
        </div>
      </div>
    );
  };

  renderIncomplete = () => {
    const sorryTextStyle = {
      fontFamily: "HelveticaNeue-Bold",
      fontSize: "16px",
      color: "#99B5B7",
      letterSpacing: "0.14px",
      textAlign: "center",
      paddingTop: 30
    };

    return (
      <div className="outerStack-mobile sm:outerStack">
        <div style={sorryTextStyle}>INVALID INFORMATION SUPPLIED</div>
        <SadFace style={{ margin: "0 auto" }} className="py-8" />
        <div
          className="stepDescriptionText"
          style={{ margin: "0 auto", maxWidth: 300 }}
        >
          Some of your info is invalid or incomplete.
        </div>
        <div className="innerStack">
          <div
            className="textContainer"
            style={{ maxWidth: 300, paddingTop: 12 }}
          >
            <span>
              Go back and check all your personal information again - we could
              not verify all of your data! If this issue persists, please{" "}
            </span>
            <a href={contactUrl} style={{ color: "#28EBC1" }}>
              contact us
            </a>{" "}
            to resolve the issue.
          </div>

          <input
            type="button"
            onClick={this.props.previousStep}
            name="button"
            value="Fix my Application"
            className="continueButton"
            style={{ backgroundColor: "black" }}
          />
        </div>
      </div>
    );
  };

  // Your profile information is incomplete.

  render() {
    const {
      renderApproved,
      renderDenied,
      renderPending,
      renderIdInvalid,
      renderIncomplete
    } = this;
    const {
      approved,
      pending,
      idInvalid,
      hints,
      reason,
      decisionRan
    } = this.props.step;
    // This is terrible, fix it. Use codes instead or something. Problem is Synapse
    // just sends this in their extra.note. How do we filter this without comparing strings?
    const incompleteReason = "Your profile information is incomplete.";

    // TODO: Right now we only approve or deny people. There is no implementation
    // for a "pending" state.
    if (
      !this.props.noPropsCheck &&
      approved === null &&
      !this.props.step.decisionRan
    ) {
      return (
        <div className="fixed-centered">
          <p>Well, you're not supposed to be here :/</p>
          <p>Sending you back to a safe place...</p>
        </div>
      );
    }

    // TODO: Make sure 'approved' is checking bool value
    return (
      <div className="stepContainer">
        <Header />
        <div className="innerStepContainer">
          {decisionRan
            ? renderPending()
            : idInvalid
            ? renderIdInvalid()
            : pending
            ? renderPending()
            : approved
            ? renderApproved()
            : reason == incompleteReason
            ? renderIncomplete()
            : renderDenied()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.register.user,
    step: state.register.decision
  }),
  actions
)(Decision);
